// This function now receives `record` dynamically
import SeverityCell from "../../../customAssets/severityCell.js";

export const getPermissionsData = (record) =>
  Object.entries(record.permissions || {}).map(
    ([permission, details], index) => ({
      id: index,
      name: permission,
      status: details.status,
      info: details.info,
      description: details.description,
    })
  );

// Static columns definition
export const permissionsColumns = [
  {
    Header: "Permission",
    accessor: "name",
  },
  {
    Header: "Status",
    accessor: "status",
    Cell: SeverityCell,
  },
  {
    Header: "Info",
    accessor: "info",
  },
  {
    Header: "Description",
    accessor: "description",
  },
];

export const permissionsTitle = "category-title-permissions";
